import { BarMeldingType } from './bar-melding-type.enum';

export class BarMelding{
    id: number;
    startDate?: Date;
    endDate?: Date;
    meldingType: BarMeldingType;
    location: string;
    content: string;
    title: string;
    zone: string;

    convert(m: any): this {
        const meldingTypeMapping = {
            20: BarMeldingType.Opgelost,
            40: BarMeldingType.Informatief,
            60: BarMeldingType.Belangrijk,
            80: BarMeldingType.Onbeschikbaar,
            90: BarMeldingType.Banner
        };

        if (m.baas === true){
            //BaaS melding
            if(m.version === '2'){
                // V2
                const readField = (m, field: string) => m.fields?.find(f => f.name === field)?.content;

                Object.assign(this, {
                    id: m.meldingId,
                    startDate: m.validFrom,
                    endDate: m.validUntil,
                    meldingType: m.meldingType,
                    location: m.urlPattern,
                    content: readField(m, 'TEKST'),
                    title: readField(m, 'TITEL'),
                    zone: m.zone
                });               
            }
            else {
                Object.assign(this, {
                    id: m.meldingId,
                    startDate: m.validFrom,
                    endDate: m.validUntil,
                    meldingType: meldingTypeMapping[m._mtype],
                    location: m.urlPattern,
                    content: m.meldingText,
                    zone: m.zone
                });
            }
        }
        //BAR melding
        else{
            Object.assign(this, {
                id: m.id,
                startDate: m.startDatum,
                endDate: m.eindDatum,
                meldingType: meldingTypeMapping[m.meldingType],
                location: m.locatie,
                content: m.tekst,
                zone: m.zone
            });
        }
        return this;
    }
}
